import { AfterViewInit, Component, EventEmitter, Input, Output } from "@angular/core";

export class BpSavingsFilterOption {
	public name: string = "";
	public value: string = "";
}

@Component({
	selector: "base-filter",
	templateUrl: "./base-filter.component.html",
	styleUrls: ["./base-filter.component.scss"],
	standalone: false
})
export class BaseFilterComponent implements AfterViewInit {
	@Input()
	public initialFilter: BpSavingsFilterOption = null;
	@Input()
	public initialList: BpSavingsFilterOption[] = [];

	@Output()
	public onSelect: EventEmitter<BpSavingsFilterOption> = new EventEmitter<BpSavingsFilterOption>(); // Event triggered on filter click

	public currentFilter: BpSavingsFilterOption;
	public filterList: BpSavingsFilterOption[] = [];

	public ngAfterViewInit(): void {
		this.filterList = this.initialList;
		this.setFilter(this.initialFilter);
	}

	public onFilterClick(filter: BpSavingsFilterOption): void {
		this.setFilter(filter);
	}

	private setFilter(f: BpSavingsFilterOption): void {
		this.currentFilter = f;
		this.onSelect.emit(f);
	}
}
